import { apiSlice } from "./apiSlice";
export const rolesSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getAllRoles: builder.query({
            query: (params) => ({
                url: `Roles`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            // providesTags: ["AllActionTracker"],
        }),
    }),
});

export const { useGetAllRolesQuery } = rolesSlice;
